import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Setup from '@/views/Setup.vue';
import Login from '@/views/Login.vue';
import Account from '@/views/Account.vue';
import GrowthCycles from '@/views/GrowthCycles.vue';
import Todos from '@/views/Todos.vue';
import Planning from '@/views/Planning.vue';
import Analytics from '@/views/Analytics.vue';
import UsersComponent from '@/components/users/Users.vue';
import FarmsComponent from '@/components/farms/Farms.vue';
import CropsComponent from '@/components/crops/Crops.vue';
import CropCodesComponent from '@/components/crops/CropCodes.vue';
import GrowthCyclesComponent from '@/components/growth_cycles/GrowthCycles.vue';
import GrowthCycleTemplatesComponent from '@/components/growth_cycles/GrowthCycleTemplates.vue';
import GrowthCycleTemplateComponent from '@/components/growth_cycles/GrowthCycleTemplate.vue';
import firebase from 'firebase';
import store from './store';

Vue.use(Router);

const router = new Router({

  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/login',
    },
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/growth_cycles',
      component: GrowthCycles,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '/',
          name: 'growthCycles',
          component: GrowthCyclesComponent,
          meta: {
            requiresAuth: true,
          },
        },
     ],
    },
    {
      path: '/todo',
      name: 'todo',
      component: Todos,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/planning',
      name: 'planning',
      component: Planning,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: Analytics,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/setup',
      name: 'setup',
      component: Setup,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'users',
          name: 'users',
          component: UsersComponent,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'farms',
          name: 'farms',
          component: FarmsComponent,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'crops',
          name: 'crops',
          component: CropsComponent,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'crop-codes',
          name: 'cropCodes',
          component: CropCodesComponent,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'templates',
          name: 'growthCycleTemplates',
          component: GrowthCycleTemplatesComponent,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/setup/templates/:id',
      name: 'growthCycleTemplate',
      component: GrowthCycleTemplateComponent,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      component: Login,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next('login');
  } else if (!requiresAuth && currentUser) {
    store.dispatch('getCurrentUser');
    next('home');
  } else {
    store.dispatch('getCurrentUser');
    next();
  }
});

export default router;
